import React from 'react';
import Modal from 'react-modal';
import { ButtonComment } from '../ButtonComment';
import { ProductRatingForm } from '../ProductRatingForm';
import useNewReactModal from '../../hooks/useNewReactModal';

interface NewReactModalProps {
  productId: number;
  productTitle: string;
  productImage: string;
  headerTitle: string;
  modalId: string;
  siteKey: string;
  csrfToken: string;
  isLink?: boolean;
  textLink?: string;
}

function NewReactModal({
  productId,
  productTitle,
  productImage,
  headerTitle,
  modalId,
  siteKey,
  csrfToken,
  isLink,
  textLink,
}: NewReactModalProps) {
  const { openModal, closeModal, modalIsOpen } = useNewReactModal();

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '20px 20px 10px 20px',
      maxHeight: '92vh',
    },
    overlay: {
      zIndex: 1000,
    },
  };

  return (
    <>
      <div id="modal-react" className="modal">
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          id={modalId}
          appElement={document.getElementById('modal-react') as HTMLElement}
        >
          <span className="modal-content">
            <div className="modal-header">
              <p className="modal-header-title">{headerTitle}</p>
              <button className="modal-close-button" onClick={closeModal}>
                <img
                  src="../../img/backend/icons/close-button-modal.svg"
                  alt="Close"
                />
              </button>
            </div>
            <div className="modal-body">
              <ProductRatingForm
                productId={productId}
                productTitle={productTitle}
                productImage={productImage}
                csrfToken={csrfToken}
                closeModal={closeModal}
                siteKey={siteKey}
              />
            </div>
          </span>
        </Modal>
      </div>
      {isLink ? (
        <a href="javascript:void(0);" onClick={openModal}>
          {textLink}
        </a>
      ) : (
        <ButtonComment onClick={openModal} />
      )}
    </>
  );
}

export default NewReactModal;
